export default __webpack_public_path__ + "static/media/home.45af141c.png";